import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { TipTypeEnum } from '@anecdotes/design-system/tips';
import { TrustCenterModalService } from '../../../../services';
import { FeatureFlagsService } from '@anecdotes/feature-flags';
import { ContactList, TrustCenterFacadeService, TrustCenterNavigationService } from '@anecdotes/shared-trust-center';

@Component({
  selector: 'app-salesforce-automatic-approvals',
  templateUrl: './salesforce-automatic-approvals.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SalesforceAutomaticApprovalsComponent implements OnInit {
  readonly MAX_ALLOWED_LISTS = 50;

  @HostBinding('class')
  private readonly class = 'flex w-full flex-col gap-4 text-base';

  protected readonly TipTypeEnum = TipTypeEnum;

  contactLists$: Observable<ContactList[]>;

  get isEvidenceLabDisabled(): boolean {
    return !this.featureFlagsService.isEnabledSync('@evidence-lab-page');
  }

  constructor(
    private readonly trustCenterModalService: TrustCenterModalService,
    private readonly trustCenterNavigationService: TrustCenterNavigationService,
    private readonly trustCenterFacade: TrustCenterFacadeService,
    private readonly featureFlagsService: FeatureFlagsService,
  ) {}

  ngOnInit(): void {
    this.contactLists$ = this.trustCenterFacade.getContactLists();
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.settings.automations.salesforceAutomaticApprovals.${key}`;
  }

  navigateToEvidenceLab(): void {
    this.trustCenterNavigationService.navigateToEvidenceLab();
  }

  async openEvidencePoolModal(): Promise<void> {
    const filteredIds = (await firstValueFrom(this.contactLists$))?.map((list) => list.evidence_id);
    this.trustCenterModalService.openEvidencePoolModal(filteredIds);
  }
}
